import React from "react";
import Flex from "./Flex";
import styled from "styled-components";

const FlexCenter = styled(Flex)`
  justify-content: center;
`;

export default FlexCenter;
